(() => {
  const osFormSelector = ".os-iubenda-consent-form";
  const osTimeoutMs = 12000;

  const osSetSubmitting = (osForm, osSubmitting) => {
    osForm.setAttribute("aria-busy", String(osSubmitting));
    osForm.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((osButton) => {
      if (osSubmitting) {
        osButton.dataset.osWasDisabled = String(osButton.disabled);
        osButton.disabled = true;
      } else {
        osButton.disabled = osButton.dataset.osWasDisabled === "true";
        delete osButton.dataset.osWasDisabled;
      }
    });
  };

  const osShowError = (osForm) => {
    const osError = osForm.querySelector("[data-os-iubenda-error]");
    if (osError) {
      osError.hidden = false;
      osError.focus({ preventScroll: true });
      const osReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      osError.scrollIntoView({ block: "nearest", behavior: osReduceMotion ? "auto" : "smooth" });
    }
  };

  const osHideError = (osForm) => {
    const osError = osForm.querySelector("[data-os-iubenda-error]");
    if (osError) osError.hidden = true;
  };

  document.addEventListener(
    "submit",
    (osEvent) => {
      const osForm = osEvent.target;
      if (!(osForm instanceof HTMLFormElement) || !osForm.matches(osFormSelector)) return;

      const osConsentInput = osForm.querySelector("[data-cons-preference]");
      if (!osConsentInput) return;

      osEvent.preventDefault();
      if (!osForm.checkValidity()) {
        osForm.reportValidity();
        return;
      }

      const osEmailInput = osForm.querySelector('[data-cons-subject="email"]');
      const osEmail = osEmailInput?.value.trim().toLowerCase() || "";
      if (!osEmail || !window._iub?.cons_instructions) {
        osShowError(osForm);
        return;
      }

      osHideError(osForm);
      osSetSubmitting(osForm, true);

      let osSettled = false;
      const osFinishWithError = () => {
        if (osSettled) return;
        osSettled = true;
        window.clearTimeout(osTimeout);
        osSetSubmitting(osForm, false);
        osShowError(osForm);
      };
      const osTimeout = window.setTimeout(osFinishWithError, osTimeoutMs);

      try {
        window._iub.cons_instructions.push([
          "submit",
          {
            writeOnLocalStorage: false,
            form: { selector: osForm },
            consent: {
              subject: {
                id: osEmail.replace(/\W/g, "-"),
                email: osEmail,
              },
              legal_notices: [{ identifier: "privacy_policy" }],
            },
          },
          {
            success: () => {
              if (osSettled) return;
              osSettled = true;
              window.clearTimeout(osTimeout);
              HTMLFormElement.prototype.submit.call(osForm);
            },
            error: osFinishWithError,
          },
        ]);
      } catch {
        osFinishWithError();
      }
    },
    true,
  );
})();
